/* Third Door — theme JS.
   Deliberately small and dependency-free. Every byte here is downloaded over
   4G by someone deciding whether to trust you, so there is no framework. */

(function () {
  'use strict';

  /* ---------------- Mobile navigation drawer ---------------- */

  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;

    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.setAttribute('data-open', 'true');
      drawer.removeAttribute('hidden');
      document.body.setAttribute('data-drawer-open', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.setAttribute('data-open', 'false');
      document.body.removeAttribute('data-drawer-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocused) lastFocused.focus();
      window.setTimeout(function () {
        if (drawer.getAttribute('data-open') !== 'true') drawer.setAttribute('hidden', '');
      }, 300);
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') close();
    });
  }

  /* ---------------- Sticky CTA bar (mobile) ----------------
     Appears once the visitor has committed to reading — showing it
     immediately reads as pressure, which is what we are avoiding. */

  function initStickyCta() {
    var bar = document.querySelector('[data-sticky-cta]');
    if (!bar) return;

    var threshold = 500;
    var ticking = false;

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var atBottom = (y + window.innerHeight) >= (document.body.scrollHeight - 120);
      bar.setAttribute('data-visible', y > threshold && !atBottom ? 'true' : 'false');
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });

    update();
  }

  /* ---------------- Click-to-load scheduler ----------------
     Calendly/Cal.com embeds are several hundred KB. We do not pay that
     cost until the visitor actually intends to book. */

  function initBookingEmbeds() {
    document.querySelectorAll('[data-booking]').forEach(function (host) {
      var url = host.getAttribute('data-booking-url');
      if (!url) return;

      var trigger = host.querySelector('[data-booking-load]');

      function load() {
        var frame = document.createElement('iframe');
        frame.src = url;
        frame.title = 'Booking calendar';
        frame.loading = 'lazy';
        frame.setAttribute('allow', 'camera; microphone; fullscreen; payment');
        host.innerHTML = '';
        host.appendChild(frame);
      }

      if (trigger) {
        trigger.addEventListener('click', function (e) { e.preventDefault(); load(); });
      } else {
        load();
      }
    });
  }

  /* ---------------- Anchor nav current-section state ---------------- */

  function initAnchorNav() {
    var nav = document.querySelector('[data-anchornav]');
    if (!nav || !('IntersectionObserver' in window)) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var targets = links
      .map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); })
      .filter(Boolean);
    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (a) {
          var active = a.getAttribute('href') === '#' + entry.target.id;
          if (active) { a.setAttribute('aria-current', 'true'); a.style.color = 'var(--navy)'; a.style.borderBottomColor = 'var(--gold)'; }
          else { a.removeAttribute('aria-current'); a.style.color = ''; a.style.borderBottomColor = ''; }
        });
      });
    }, { rootMargin: '-30% 0px -60% 0px' });

    targets.forEach(function (t) { observer.observe(t); });
  }

  /* ---------------- Accordion: only one open at a time ---------------- */

  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('details'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }

  /* ---------------- Qualification gate ----------------
     The calendar stays hidden until the form is submitted, so calls
     arrive pre-qualified rather than as tyre-kickers. */

  function initQualificationGate() {
    var gate = document.querySelector('[data-gate]');
    var calendar = document.querySelector('[data-gate-target]');
    if (!gate || !calendar) return;

    // Shopify re-renders the page after a successful contact-form post, and the
    // success message carries [data-gate-passed]. Liquid already unhides the
    // calendar in that case; this is the belt-and-braces path, and it also
    // scrolls the visitor to the thing they just unlocked.
    if (!gate.querySelector('[data-gate-passed]')) return;

    calendar.removeAttribute('hidden');
    calendar.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initDrawer();
    initStickyCta();
    initBookingEmbeds();
    initAnchorNav();
    initAccordions();
    initQualificationGate();
  });
})();
